const isValidMass = (mass) => {
    if (!mass || mass === "")
        return true;

    mass = Number.parseFloat(mass);
    return !Number.isNaN(mass) &&
            mass > 0;
}

export default isValidMass;